import React from 'react'
import { Message } from '@/components/Message'

interface Props {
  fallback?: React.ReactNode
  children: React.ReactNode
}
export class ErrorBoundary extends React.Component<Props> {
  state = { hasError: false }

  componentDidCatch(error) {
    global.Sentry && global.Sentry.captureException(error)
    this.setState({ hasError: true })
  }

  render() {
    const {
      fallback = <Message>Возникла непредвиденная ошибка :(</Message>,
      children
    } = this.props

    return this.state.hasError ? fallback : children
  }
}